import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { composePageTitle } from './Common';
import Footer from './components/Footer';
import Header from './components/Header';
import Application from './config/application';
import { PageUrl } from './Constants';

const About = () => {
    return (
        <div id="main-wrapper">
            <Helmet title={composePageTitle('About Us')} />
            <Header />
            <section className="page-header page-header-dark bg-secondary">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-8">
                            <h1>About Us</h1>
                        </div>
                        <div className="col-md-4">
                            <ul className="breadcrumb justify-content-start justify-content-md-end mb-0">
                                <li>
                                    <RouterLink to={PageUrl.HOME}>Home</RouterLink>
                                </li>
                                <li className="active">About Us</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <div id="content">
                <div className="container">
                    <div className="bg-white shadow-md rounded p-4 mb-4">
                        <h2 className="text-6">{Application.ORG_DISPLAY_NAME} – Your Reliable Partner for Budget-Friendly, Hassle-Free Travel</h2>
                        <p>
                            {' '}
                            Travel isn’t just a pause from everyday life—it’s a chance to recharge, discover new destinations, and make lasting memories. At {Application.ORG_DISPLAY_NAME}, we know how important it is to plan the perfect trip without the stress of complicated logistics or expensive fares. That’s why we’re committed to streamlining the booking process and delivering the best deals on flights and vacation packages, so your next adventure is as affordable as it is unforgettable.
                        </p>

                        <h2 className="text-6">Who We Are</h2>
                        <p>
                            {Application.ORG_DISPLAY_NAME} is a top-tier online travel agency based in the U.S., committed to making travel both affordable and accessible for all. Backed by years of industry expertise, our team excels at finding the best deals on flights, hotels, and vacation packages—helping you stretch your travel budget without compromising on quality or experience.{' '}
                        </p>

                        <h2 className="text-6">Our Promise to You</h2>
                        <p>
                            At {Application.ORG_DISPLAY_NAME}, we believe that travel should be easy, budget-friendly, and completely hassle-free. Whether you're organizing a business trip, a family holiday, or a spontaneous escape, we handle the logistics—so you can focus on enjoying the journey and making the most of every moment.
                        </p>

                        <h2 className="text-6">Get in Touch</h2>
                        <p>
                            Need help with your travel plans? Our dedicated support team is just a call or email away, ready to assist you with prompt and personalized service.
                        </p>

                        <h2 className="text-6">Why Choose {Application.ORG_DISPLAY_NAME}?</h2>
                        <p>
                            Need help with your travel plans or have a question? Our friendly support team is just a call or email away. We’re here to provide fast, personalized assistance to ensure your booking experience is smooth and stress-free.
                        </p>

                        <ul className="custom-bullet-list">
                            <li><strong>Extensive Choices</strong> –  With access to top airlines and hotel networks worldwide, we offer a wide range of travel options to suit every need and budget.</li>
                            <li><strong>Expert Assistance</strong> – Our experienced and friendly customer support team is available 24/7 to guide you every step of the way.</li>
                            <li><strong>Seamless Booking</strong> – Our intuitive platform makes it easy to compare, book, and manage your trips in just a few clicks.</li>
                            <li><strong>Customer-First Approach</strong> – Your satisfaction is our highest priority. We go above and beyond to ensure your travel experience is smooth and enjoyable.</li>
                        </ul>

                        <div className="row mt-4 mb-2">
                            <div className="col-md-4">
                                <div className="featured-box style-1">
                                    <div className="featured-box-icon text-primary">
                                        {' '}
                                        <i className="far fa-thumbs-up"></i>
                                    </div>
                                    <h3>Best Deal Offer</h3>
                                    <p>
                                        Find our lowest deal to destinations worldwide, guaranteed
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="featured-box style-1">
                                    <div className="featured-box-icon text-primary">
                                        {' '}
                                        <i className="far fa-paper-plane"></i>{' '}
                                    </div>
                                    <h3>Easy Booking</h3>
                                    <p>
                                        Search, select and save - the fastest way to book your trip
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="featured-box style-1">
                                    <div className="featured-box-icon text-primary">
                                        {' '}
                                        <i className="far fa-eye"></i>{' '}
                                    </div>
                                    <h3>24/7 Customer Care</h3>
                                    <p>
                                        Get unpublished deals by calling{' '}
                                        {Application.SUPPORT_PHONE}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default About;